import { LatestSignup } from "@/builders/types/admin-dashboard";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<LatestSignup>();

export const columns = [
  columnHelper.display({
    id: "sequence",
    header: "#",
    cell: ({ row }) => row.index + 1,
  }),
  columnHelper.accessor("first_name", {
    header: "First Name",
    enableSorting: true,
  }),
  columnHelper.accessor("last_name", {
    header: "Last Name",
    enableSorting: true,
  }),
  columnHelper.accessor("email", {
    header: "Email",
    enableSorting: true,
  }),
  columnHelper.accessor("staff_id", {
    header: "Staff ID",
    enableSorting: true,
  }),
  columnHelper.accessor("department", {
    header: "Module",
    enableSorting: true,
  }),
];

export const columnOrdering = [
  "sequence",
  "first_name",
  "last_name",
  "email",
  "staff_id",
  "department",
];
